import { useEffect, useState } from 'react';
import { emApp } from '@/lib/app';
import Logo from '@/components/ui/Logo';

// Tela de abertura para o app instalado (iOS não gera splash sozinho).
// Fundo claro com o logo centralizado por ~400ms enquanto a Home carrega.
export default function SplashApp() {
  const [visivel, setVisivel] = useState(emApp());

  useEffect(() => {
    if (!emApp()) return;
    const t = window.setTimeout(() => setVisivel(false), 400);
    return () => window.clearTimeout(t);
  }, []);

  if (!visivel) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center"
      style={{ background: '#f6f7fb' }}
    >
      <Logo imgClassName="h-20 w-auto object-contain" />
    </div>
  );
}